<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
      <div class='container-fluid'>
          <div class='col-lg-12' style='padding:0px'>
            <table width='100%' class='table  table-bordered ' >
                  <thead>
                    <tr>
                        <th style='text-align: center'>التاريخ</th>
                        <th style='text-align: center'>الحركة</th>
                        <th style='text-align: center'>الفنى</th>
                        <th style='text-align: center'>المطلوب</th>
                        <th style='text-align: center'>المدفوع</th>
                        <th style='text-align: center'>الرصيد</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr v-for='record in records' :key='record.id'>
                        <td style="padding:2px" align='center'>{{record.date}}</td>
                        <td style="padding:2px" align='center'>{{record.type}}</td>
                        <td style="padding:2px" align='center'>{{record.name}}</td>
                        <td style="padding:2px" align='center'>{{record.amount}}</td>
                        <td style="padding:2px" align='center'>{{record.paid}}</td>
                        <td style="padding:2px" align='center'>{{record.total}}</td>
                      </tr>
                  </tbody>
              </table>
              <!-- /.table-responsive -->
          <!-- /.col-lg-12 -->
          </div>
       </div>
    <!-- /.container-fluid -->
</div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'CustomerBalanceSheet',
  data () {
    return {
      isLoadingData: false,
      records: []
    }
  },
  methods: {
    tabSelected () {
      this.records = ''
      this.isLoadingData = true
      axios.post(this.$apiURL + 'customer-balance-sheet', {
        token: localStorage.getItem('token'),
        contract_id: this.$store.state.customerData.contract_id
      })
        .then(res => {
          this.records = res.data
          var total = 0
          for (let i = 0; i < this.records.length; i++) {
            total = total + this.records[i].total
            this.records[i].total = total
          }
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Contracts/CustomerBalanceSheet.vue